<template>
	<div>
		<h3 class="mt-6">Leer Politicas</h3>
	</div>
</template>

<script>
export default {};
</script>
